import React, { useState } from 'react'
import './HRTickets.css'
import { Col, Row, AutoComplete } from 'antd'
import { AlignLeftOutlined, FilterOutlined } from '@ant-design/icons';
import images1 from '../../assets/images1.jfif'

function HRTickets() {
    const mockVal = (str, repeat = 1) => ({
        value: str.repeat(repeat),
    });
    const [options, setOptions] = useState([]);
    const getPanelValue = (searchText) =>
        !searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)];
    const onSelect = (data) => {
        console.log('onSelect', data);
    };
    return (
        <div className='mt-3 ml-2'>
            <Row>
                <Col lg={4}>
                    <div className='flex justify-between'>
                        <div>
                            <AutoComplete
                                options={options}
                                style={{
                                    width: 120,
                                    height: 25,
                                    fontSize: '10px'
                                }}
                                onSelect={onSelect}
                                onSearch={(text) => setOptions(getPanelValue(text))}
                                placeholder="Search"
                            />
                        </div>
                        <div className='flex'>
                            <FilterOutlined className='hr-tic-icon ml-1' />
                            <AlignLeftOutlined className='hr-tic-icon ml-1' />
                        </div>
                    </div>
                    <div>
                        <p className='Unresolved'>Unresolved</p>
                    </div>
                    <div className='hr-pro-back'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <p className='Unresolved'>Resolved</p>

                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                    <div className='hr-pro-back1'>
                        <Row>
                            <Col sm={5}>
                                <img className="image" style={{ width: "25px", height: "25px" }} src={images1} alt="" />

                            </Col>
                            <Col sm={19}>
                                <p style={{ fontSize: "9px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Guard | Security</p>
                                <p style={{ fontSize: "8px", fontWeight: "bold" }}>Contractor | Lakshya Security</p>

                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col lg={5}>
                    <div className='ml-5'>
                        <p className='Unresolved'>+ Create New</p>
                    </div>
                    <div className='create-back ml-5 mt-4'>
                        <p className='lorem-title'>Lorem dolores quantum</p>
                        <p className='hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                        <p className='hr-date'>27 June</p>
                        <p className='hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='create-back ml-5 mt-2'>
                        <p className='lorem-title'>Lorem dolores quantum</p>
                        <p className='hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                        <p className='hr-date'>27 June</p>
                        <p className='hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='create-back ml-5 mt-2'>
                        <p className='lorem-title'>Lorem dolores quantum</p>
                        <p className='hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                        <p className='hr-date'>27 June</p>
                        <p className='hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='create-back ml-5 mt-2'>
                        <p className='lorem-title'>Lorem dolores quantum</p>
                        <p className='hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                        <p className='hr-date'>27 June</p>
                        <p className='hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='create-back ml-5 mt-2'>
                        <p className='lorem-title'>Lorem dolores quantum</p>
                        <p className='hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                        <p className='hr-date'>27 June</p>
                        <p className='hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                </Col>
                <Col lg={15}>
                    <div className='ml-5'>
                        <p className='hr-praavi'>PRAAVI Support</p>
                        <div className='hr-chat'>
                            <div className='flex justify-between hr-bo'>
                              <p className='hr-chat-contant'>Lorem dolores quantum</p>
                              <div className='mr-5'>
                                <p className='hr-resolve'>Resolve</p>
                                <p className='hr-mark'>Mark a resolve</p>
                              </div>
                            </div>
                            <div className='p-5'>
                               <div className='mt-5'>
                                <span className='chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                               </div>
                               <div className='mt-10 chat-right'>
                                <span className='chat-right1'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                               </div>
                               <div className='mt-5'> 
                                <span className='chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                               </div>
                               <div className='mt-10 chat-right'>
                                <span className='chat-right1'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                               </div>
                               <div className='mt-5'> 
                                <span className='chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                               </div>
                               <div className='mt-8'> 
                                <span className='chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                               </div>
                            </div>
                            
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default HRTickets